module.exports = __webpack_public_path__ + "img/target.4aa5721c.png";